export interface InThisNavItem {
  id: string;
  label: string;
  current?: boolean;
  children?: InThisNavItem[];
}

interface InThisNavProps {
  label: string;
  items: InThisNavItem[];
  onSelect: (id: string) => void;
}

function NavList({
  items,
  onSelect,
  nested,
}: {
  items: InThisNavItem[];
  onSelect: (id: string) => void;
  nested?: boolean;
}) {
  return (
    <ul className={nested ? 'mb-2 ml-3 flex flex-col border-l border-gray-200' : 'flex flex-col'}>
      {items.map((item) => (
        <li key={item.id}>
          <a
            href={`#${item.id}`}
            aria-current={item.current ? 'true' : undefined}
            className={`flex min-h-[44px] w-full items-center py-2 text-left text-sm transition-colors ${
              nested ? 'pl-3 ' : ''
            }${
              item.current
                ? nested
                  ? 'font-medium text-primary'
                  : 'font-medium text-gray-900'
                : 'text-gray-700 hover:text-primary'
            }`}
            onClick={(event) => {
              event.preventDefault();
              onSelect(item.id);
            }}
          >
            {item.label}
          </a>
          {item.children && item.children.length > 0 ? (
            <NavList items={item.children} onSelect={onSelect} nested />
          ) : null}
        </li>
      ))}
    </ul>
  );
}

export default function InThisNav({ label, items, onSelect }: InThisNavProps) {
  if (items.length === 0) return null;

  return (
    <nav aria-label={label}>
      <p className="text-xs font-semibold uppercase tracking-wide text-gray-500 mb-2">{label}</p>
      <NavList items={items} onSelect={onSelect} />
    </nav>
  );
}
